import React, { useState } from 'react';
import { node, string } from 'prop-types';
import { Popover, Position, Button, Card, Menu } from '@chaser/components';

const OptionsMenu = ({ children, appearance = 'minimal', size = 'narrow' }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <Popover
      onToggle={setMenuOpen}
      shown={menuOpen}
      position={Position.BOTTOM_RIGHT}
      target={<Button size={size} appearance={appearance} active={menuOpen} icon="options" />}
    >
      <Card>
        <Menu>{children}</Menu>
      </Card>
    </Popover>
  );
};

OptionsMenu.propTypes = { children: node.isRequired, appearance: string, size: string };

export default OptionsMenu;
